import { SiteNumberAndName } from '@csp/csp-common-hbs-model';
import { isDefined } from '@csp/csp-common-util';
import { ScheduleVisitTexts } from '@csp/csp-common-visits';
import { Grid, ListTextIconCol } from '@csp/csp-web-ui';
import { uniq } from 'lodash/fp';
import { FC } from 'react';
import { BioSampleKitCodeCol } from '../../component/BioSampleKitCodeCol';
import { BioSamplingExpiryDateCol } from '../../component/BioSamplingExpiryDateCol';
import { KitDescriptionCol } from '../../component/KitDescriptionCol';
import { KitTypeCol } from '../../component/KitTypeCol';
import { BioSampleContentService } from '../../service/BioSampleContentService';
import { KitDetails } from '../model/KitDetails';
import { KitContainerSiteAlert } from './KitContainerSiteAlert';

type Props = {
  kitDetails: KitDetails;
  supportedVisits: ScheduleVisitTexts[];
  mismatchingSites: SiteNumberAndName[];
};

export const KitInformation: FC<Props> = ({ kitDetails, supportedVisits, mismatchingSites }) => {
  const texts = BioSampleContentService.getKitDetailsTexts();

  return (
    <Grid data-testid="bio-sample-kit-details-section" container spacing={2}>
      <Grid item xs={12}>
        <KitContainerSiteAlert mismatchingSites={mismatchingSites} />
      </Grid>
      <BioSampleKitCodeCol
        kitCode={kitDetails?.kitCode}
        kitCodeLabel={texts.drawer.header.kitCode.text}
        hideTitle={false}
        xs={6}
        md={3}
      />

      <KitTypeCol
        kitType={kitDetails?.kitType}
        kitTypeLabel={texts.drawer.header.kitType.text}
        hideTitle={false}
        xs={6}
        md={3}
      />

      <BioSamplingExpiryDateCol
        label={texts.drawer.header.kitExpiryDate.text}
        expiryDate={kitDetails?.kitExpirationDateStr}
        hideTitle={false}
        xs={6}
        md={3}
      />

      <KitDescriptionCol
        kitDescriptionLabel={texts.drawer.header.kitDescription.text}
        description={kitDetails?.kitDescription}
        hideTitle={false}
        xs={6}
        md={6}
      />

      <ListTextIconCol
        title={texts.drawer.header.supportedVisits.text}
        text={uniq(supportedVisits.map(supportedVisit => supportedVisit.title))
          .filter(isDefined)
          .join(', ')}
        hideTitle={false}
        xs={12}
        md={6}
      />
    </Grid>
  );
};
